import React from "react";
import { SolicitationView } from "../../../models/SolicitationView";
import LcTooltip from "../../../components/Generic/LcTooltip";
import './index.css';

interface Props {
  solicitation: SolicitationView,
  width: string,
  height: string
}

const AttendanceSlaSloBar: React.FC<Props> = (props) => {

  return (
    <div className={"divOrderSla"}>
      <div>
        <LcTooltip content={<span style={{ color: props.solicitation.slaCor, fontSize: "12px" }}>{`${props.solicitation.slaPercentual}%`}</span>}>
          <div style={{ width: props.width, height: props.height, backgroundColor: "lightgray" }}> {/* barra */}
            <div style={{ width: `${props.solicitation.slaPercentual}%`, height: props.height, backgroundColor: props.solicitation.slaCor }} /> {/* cor da barra */}
          </div>
        </LcTooltip>
      </div>

      <br />

      <div>
        <LcTooltip content={<span style={{ color: props.solicitation.sloCor, fontSize: "12px" }}>{`${props.solicitation.sloPercentual}%`}</span>}>
          <div style={{ width: props.width, height: props.height, backgroundColor: "lightgray" }}>
            <div style={{ width: `${props.solicitation.sloPercentual}%`, height: props.height, backgroundColor: props.solicitation.sloCor }} />
          </div>
        </LcTooltip>
      </div>
    </div>
  )
}

export default AttendanceSlaSloBar;